
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { BuscarUsuarioResponse, UsuarioProps, UsuarioResponse } from '../../interfaces/admin/UsuarioInterface';

export const Usuarios = () => {

    return new Promise<UsuarioProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/', token)
                .then(({ data }: { data: UsuarioProps[] }) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve([]);
                });
        }

    });

}

export const ActualizarUsuario = (params: UsuarioProps) => {

    return new Promise<UsuarioResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Actualizar', params, token)
                .then(({ data }: { data: UsuarioResponse }) => {
                    resolve(data);
                })
                .catch((error: AxiosError) => {
                    resolve({
                        success: false,
                        message: error.message,
                        idUsuario: 0,
                        curp: '',
                        nombre: '',
                        apellido1: '',
                        apellido2: '',
                        correoElectronico: '',
                        contrasena: '',
                        activo: false,
                        idTipoUsuario: 0,
                        idUnidad: 0,
                    });
                });
        }

    });

}

export const AgregarUsuario = (params: UsuarioProps) => {

    return new Promise<UsuarioResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Agregar', params, token)
                .then(({ data }: { data: UsuarioResponse }) => {
                    resolve(data);
                })
                .catch((error: AxiosError) => {
                    resolve({
                        success: false,
                        message: error.message,
                        idUsuario: 0,
                        curp: '',
                        nombre: '',
                        apellido1: '',
                        apellido2: '',
                        correoElectronico: '',
                        contrasena: '',
                        activo: false,
                        idTipoUsuario: 0,
                        idUnidad: 0,
                    });
                });
        }

    });

}

export const ObtenerUsuarioUnidad = (id: number) => {
    return new Promise<UsuarioProps[]>((resolve, eject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.get(`/Api/Usuario/ObtenerUsuarioUnidad/${id}`, token)
                .then(({ data }: { data: UsuarioProps[] }) => {
                    resolve(data); 
                })
                .catch((_: AxiosError) => {
                    resolve([]);
                });
        } else {
            resolve([]);
        }
    });
};

export const BuscarUsuarioRH = ( curp: string ) => {

    return new Promise<BuscarUsuarioResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Usuario/BuscarUsuario/${ curp }`, token)
            .then( ({ data } : { data : BuscarUsuarioResponse} ) => {
                resolve( data );
            })
            .catch( (error: AxiosError) => {
                
                const data: BuscarUsuarioResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}